import Vuex from "vuex";
import Vue from "vue";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./states";
import modules from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules
});
